import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SessionStorageService } from 'ngx-webstorage';
import { AuthenticationService } from '../../authentication/authentication.service';

@Injectable()
export class AuthInterceptorService implements HttpInterceptor
{
    constructor(
        private authService: AuthenticationService,
        private sessionStorageService: SessionStorageService) { }

    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>
    {
        const currentUser = this.authService.currentUser;
        const isTotpVerification = request.url.indexOf('/authenticate/code/verify') >= 0 ||
            request.url.indexOf('/authenticate/code/send') >= 0;
        const isLogout = request.url === '/logout';

        // If authenticated, set Authorization header. Must not inject bearer token if url contains /csp/
        if ((currentUser && request.url.indexOf('/csp/') === -1) || isTotpVerification || isLogout)
        {
            const token = isTotpVerification ? this.authService.totpToken :
                isLogout ? this.sessionStorageService.retrieve('logout_token') : currentUser.token;

            if (isLogout) { this.sessionStorageService.clear('logout_token'); }

            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${token}`
                }
            });
        }
        return next.handle(request);
    }
}

